module.exports = __webpack_public_path__ + "static/img/menu_6.e67bb86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconMenu/menu_6.png
// module id = 19np
// module chunks = 2